import classnames from "classnames"
import { trackClickAddTrigger } from "./utils/telemetry"

import "./diy_tanda_selected.scss"

interface Props {
  disabled?: boolean
  label: "if" | "then"
  onClick: () => void
}

export default function DIYTandaSelect({ label, disabled = false, onClick }: Props) {
  const placeholder = label == "if" ? "this" : "that"
  const classes = classnames("tanda-select-block", {
    disabled,
    "then-that": placeholder === "that",
  })

  const click = () => {
    trackClickAddTrigger({ step: label == "if" ? "trigger" : "action" })

    onClick()
  }

  return (
    <section styleName={classes} onClick={disabled ? () => {} : click}>
      <span styleName="label">
        {label} {placeholder}
      </span>
      <button className="button-tertiary button-on-color">Add</button>
    </section>
  )
}
